import { render, staticRenderFns } from "./BasePreview.vue?vue&type=template&id=806b7f4c&scoped=true&lang=pug&"
import script from "./BasePreview.vue?vue&type=script&lang=js&"
export * from "./BasePreview.vue?vue&type=script&lang=js&"
import style0 from "./BasePreview.vue?vue&type=style&index=0&id=806b7f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806b7f4c",
  null
  
)

export default component.exports